import { createPageApp } from '@/lib/createPageApp'
import RequiresUserPage from './RequiresUserPage.vue'

createPageApp(RequiresUserPage).mount()
